import BaseCtrl from 'edge/platform/base/BaseCtrl';
import PolicyLandingUtil from 'edge/gateway/util/policylanding/PolicyLandingUtil';

var fn = function fn($scope, $state, $q, $stateParams, SearchService, $filter, ActivityService, UserService, UserInfoService, AccountService, PolicyService, ViewModelService, ModalService, $rootScope) {
    var ctrl = Object.create(BaseCtrl);
    $scope.isAgent = UserInfoService.isAgent();

    ctrl.init = function () {
        $scope.loadingComplete = false;
        angular.element('html').height('1180px');
        ctrl.getUserDetails();
        $scope.pageTitle = $filter('translate')('gateway.views.activities.Activities for the next 7 days');
        /* Search Initialisation */
        $scope.searchRequest = {
            searchParam: '',
            previousSearchParam: ''
        };

        $scope.searchResults = {
            accounts: [],
            policies: []
        };

        $scope.accountInfos = [];
        $scope.policyInfos = [];

        $scope.searchCompleted = false;
        ctrl.search($scope.searchRequest.searchParam);
        $scope.searchLoading = false;
        if ($scope.isAgent) {
            $scope.loadingDashboardTiles = true;
            $scope.loadingActivities = false;
            $scope.loadingAgents = false;
            $scope.selectedProducerCode = {};

            $scope.$on('dashboardTilesLoaded', function () {
                $scope.loadingDashboardTiles = false;
            });
        } else {
            $scope.loadingDashboardTiles = false;
            $scope.loadingActivities = false;
            $scope.loadingAgents = false;
            $scope.loadingAccounts = true;

            getRecentlyViewedAccounts().then(function (accounts) {
                $scope.loadingAccounts = false;
                $scope.recentlyVisitedAccounts = accounts.slice(0, 10).map(function (account) {
                    return mapAccount(account);
                }) || [];
            });

            getRecentlyViewedPolicies().then(function (policies) {
                $scope.recentlyVisitedPolicies = policies.slice(0, 10).map(function (policy) {
                    return mapPolicy(policy);
                }) || [];
            });
        }
    };

    /* Search Funcionality */
    ctrl.search = function (searchParam) {
        $scope.searchLoading = true;
        if (searchParam.searchParam != undefined && searchParam.searchParam.length >= 5) {
            $scope.searchParamLengthValid = true;
            $scope.loadingComplete = true;
            $scope.searchRequest.previousSearchParam = $scope.searchRequest.searchParam;
            $scope.searchRequest.searchParam = $scope.searchRequest.searchParam;
            $scope.searchRequest.searchParam = { 'searchParam': $scope.searchRequest.searchParam };
            $scope.loadingComplete = false;
            $scope.searchCompleted = true;
            $scope.searchLoading = false;
            $scope.searchParam = searchParam.previousSearchParam;
            $state.go('viewSearch1', { searchParam: $scope.searchParam });
        } else {
            $scope.searchRequest.searchParam = searchParam;
            $scope.searchResultsPromise = [];
            $scope.searchCompleted = true;
            $scope.searchLoading = false;
            $scope.searchParamLengthValid = false;
        }
    };

    ctrl.getUserDetails = function () {
        var userdetails = PolicyService.getDisplayName().then(function (userdetails) {
            $scope.userResultsPromise = userdetails;
            $scope.loadingAgents = false;
            $scope.fullName = userdetails;
            if (userdetails.fullName) $scope.fullName = userdetails.fullName;
            if (userdetails.userType) $scope.userType = userdetails.userType;
            if (userdetails.emailAddress) $scope.emailAddress = userdetails.emailAddress;
            if (userdetails.primaryPhoneNumber && userdetails.city) {
                $scope.city_phone = [userdetails.city, userdetails.primaryPhoneNumber];
                $scope.city_phone = $scope.city_phone.join(', ');
            } else if (userdetails.primaryPhoneNumber) {
                $scope.city_phone = userdetails.primaryPhoneNumber;
            } else if (userdetails.city) {
                $scope.city_phone = userdetails.city;
            }
        });
    };

    var populateAccountResults = function populateAccountResults() {
        if ($scope.searchRequest.searchParam !== $scope.searchRequest.previousSearchParam) {
            while ($scope.accountInfos.length > 0) {
                $scope.accountInfos.pop();
            }
            $scope.searchResults.accounts.forEach(function (account) {
                if (account !== null) {
                    var accountInfo = {
                        accountNumber: '',
                        accountName: '',
                        FEINId: '',
                        SSNId: '',
                        RISKId: '',
                        primaryAddress: '',
                        producerCodes: [],
                        policySummaries: []
                    };

                    accountInfo.accountNumber = account.accountNumber;
                    accountInfo.accountName = account.accountHolder;
                    accountInfo.FEINId = account.msfFeinId_EXT;
                    accountInfo.SSNId = account.msfSSNId_EXT;
                    accountInfo.RISKId = account.msfRiskId_EXT;
                    accountInfo.primaryAddress = account.accountHolderAddress;
                    $scope.accountInfos.push(accountInfo);
                }
            });
        }
        return $scope.accountInfos;
    };

    var populatePolicyResults = function populatePolicyResults() {
        if ($scope.searchRequest.searchParam !== $scope.searchRequest.previousSearchParam) {
            while ($scope.policyInfos.length > 0) {
                $scope.policyInfos.pop();
            }

            $scope.searchResults.policies.forEach(function (policy) {
                if (angular.isDefined(policy.policyNumber)) {
                    var policyInfo = {
                        account: {
                            accountHolder: {
                                contactName: '',
                                firstName: '',
                                lastName: ''
                            }
                        },
                        linesOfBusiness: '',
                        policyNumber: '',
                        accountNumber: '',
                        accountName: '',
                        primaryAddress: '',
                        FEINID: '',
                        producerCode: ''
                    };

                    policyInfo.policyNumber = policy.policyNumber;
                    policyInfo.accountNumber = policy.accountNumber;
                    policyInfo.FEINID = policy.msfFeinId_EXT;
                    if (policy.accountHolder.subtype === 'Company') {
                        policyInfo.account.accountName = policy.accountHolder.contactName;
                    } else if (policy.accountHolder.subtype === 'Person') {
                        policyInfo.account.accountName = policy.accountHolder.firstName + ' ' + policy.accountHolder.lastName;
                    }
                    policyInfo.primaryAddress = policy.accountHolder.primaryAddress;
                    $scope.policyInfos.push(policyInfo);
                }
            });
        }
        return $scope.policyInfos;
    };

    function getRecentlyViewedAccounts() {
        return AccountService.getRecentlyViewedAccounts();
    }

    function getRecentlyViewedPolicies() {
        return PolicyService.getRecentlyViewedPolicies();
    }

    function mapAccount(account) {
        return {
            account: account.accountHolder,
            accountNumber: account.accountNumber,
            policies: account.policySummaries ? account.policySummaries.map(function (policySummary) {
                return {
                    policyNumber: policySummary.policyNumber,
                    lineOfBusiness: policySummary.policyLines[0].lineOfBusinessName
                };
            }) : [],
            producerCodes: account.producerCodes,
            createdDate: account.accountCreatedDate,
            address: account.accountHolderAddress,
            openActivities: account.numberOfOpenActivities,
            isCommercial: account.isCommercialAccount,
            isPersonal: account.isPersonalAccount,
            createdByMe: account.createdByMe
        };
    }

    function mapPolicy(policy) {
        return {
            account: {
                accountNumber: policy.accountNumber
            },
            accountHolderName: policy.accountHolderName,
            policyNumber: policy.policyNumber,
            latestPeriod: {
                policyLines: policy.policyLines
            },
            policyLines: policy.policyLines,
            producerCodeOfRecord: policy.producerCodeOfRecord,
            producerCodeOfService: policy.producerCodeOfService,
            primaryInsuredName: policy.primaryInsuredName,
            effective: policy.effective,
            expiration: policy.expiration,
            totalPremium: policy.premium,
            displayStatus: policy.displayStatus,
            delinquent: policy.delinquent,
            canUserView: policy.canUserView,
            createdByMe: policy.createdByMe,
            product: policy.product
        };
    }

    $scope.getPolicyTypeIcon = function (policyType) {
        return PolicyLandingUtil.getPolicyTypeIcon(policyType);
    };

    ctrl.showNewQuoteButton = function () {
        var accountPermCheckDTO = {
            permEntityType: 'Account',
            permEntityID: null,
            permission: 'create',
            isCheckPermEntity: false
        };
        var submissionPermCheckDTO = {
            permEntityType: 'Submission',
            permEntityID: null,
            permission: 'create',
            isCheckPermEntity: false
        };

        var acctPermPromise = UserService.hasUserPermission(accountPermCheckDTO);
        acctPermPromise.then(function (createAcc) {
            $scope.canCreateAccount = createAcc;
        });
        var subPermPromise = UserService.hasUserPermission(submissionPermCheckDTO);
        subPermPromise.then(function (createSub) {
            $scope.canCreateSub = createSub;
        });
    };

    ctrl.showNewQuoteButton(); // Check new quote permissions

    $scope.$watchCollection('[loadingActivities, loadingDashboardTiles,loadingAgents]', function () {
        $scope.loadingComplete = !$scope.loadingActivities && !$scope.loadingDashboardTiles && !$scope.loadingAgents;
    });

    return ctrl.create($scope);
};

fn.$inject = ['$scope', '$state', '$q', '$stateParams', 'SearchService', '$filter', 'ActivityService', 'UserService', 'UserInfoService', 'AccountService', 'PolicyService', 'ViewModelService', 'ModalService', '$rootScope'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/GatewayHomeCtrl.js
// module id = 1674
// module chunks = 0